import { createRouter, createWebHistory } from "vue-router";
import { canAccessRoute } from "@/plugins/permissions";
import Login from "@/components/Login.vue";
import ForgotPassword from "@/components/AUTH/forgot_password.vue";
import AddOtpComponent from "@/components/AUTH/add_otp.vue";
import ResetPassword from "@/components/AUTH/reset_password.vue";
import DASHBOARD from "@/components/MAIN_DASHBOARD/main_dashboard.vue";
import App_Bar_and_Navigation_Drawer from "@/components/app_bar_and_navigation_drawer.vue";
import AddProducts from '@/components/PRODUCT_MANAGEMENT/AddProducts.vue';
import addCategory from '@/components/PRODUCT_MANAGEMENT/addCategory.vue';
import ProductsList from '@/components/PRODUCT_MANAGEMENT/ProductsList.vue';
import SalesManagement from '@/components/SALES_MANAGEMENT/Sales_Management.vue';
import Total_Collections from "@/components/COLLECTION_MANAGEMENT/Total_Collections.vue";
import Total_Collections_View from "@/components/COLLECTION_MANAGEMENT/Total_Collections_View.vue";
import Daily_Collections from "@/components/COLLECTION_MANAGEMENT/Daily_Collections.vue";
import Daily_Collections_View from "@/components/COLLECTION_MANAGEMENT/Daily_Collections_View.vue";
import Overdue_Collections from "@/components/COLLECTION_MANAGEMENT/Overdue_Collections.vue";
import Overdue_Collections_Approved_List from "@/components/COLLECTION_MANAGEMENT/Overdue_Collections_Approved_List.vue";
import OrganizationManagement from '@/components/OrganizationManagement/ORGANIZATION_MANAGEMENT.vue';
import AddLeads from "@/components/LeadsManagement/AddLeads.vue";
import LeadsList from "@/components/LeadsManagement/LeadsList.vue";
import UserRegistration from "@/components/UserManagement/UserRegistration.vue";
import UsersList from "@/components/UserManagement/UsersList.vue";
import CreateUserRole from "@/components/UserManagement/CreateUserRole.vue";
import UserRoleList from "@/components/UserManagement/UserRoleList.vue";
import LiveTracking from "@/components/TrackingManagement/LiveTracking.vue";
import TrackingHistory from "@/components/TrackingManagement/TrackingHistory.vue";
import MyrouteTrackingHistary from "@/components/TrackingManagement/NonPlanTrakingHistory.vue";
import CreateRoutes from "@/components/RouteManagement/CreateRoutes.vue";
import RoutesList from "@/components/RouteManagement/RoutesList.vue";
import CreateOutlet from "@/components/OutletManagement/CreateOutlet.vue";
import OutletList from "@/components/OutletManagement/OutletList.vue";
import AllAgents from "@/components/TrackingManagement/AllAgents.vue";
import IdlingAgents from "@/components/TrackingManagement/IdlingAgents.vue";
import ParkingAgents from "@/components/TrackingManagement/ParkingAgents.vue";
import UserLog from "@/components/USER_LOG/userLog.vue";
import CategoryList from "@/components/PRODUCT_MANAGEMENT/CategoryList.vue";
import MeasurementList from "@/components/PRODUCT_MANAGEMENT/measurements.vue";
import OverallTrackingHistory from "@/components/TrackingManagement/OverallTrackingHistory.vue";
import OutletType from "@/components/OutletManagement/OutletType.vue";
import CreateOrganization from "@/components/OrganizationManagement/CreateOrganization.vue";
import OrganizationList from "@/components/OrganizationManagement/OrganizationList.vue";
import areaManagement from "@/components/upload_CSV/areaManagement.vue";
import dailyPending_inv from "@/components/upload_CSV/dailyPending_inv.vue";
import dealerInformation from "@/components/upload_CSV/dealerInformation.vue";
import stockList from "@/components/upload_CSV/stockList.vue";
import PendingPaymentReversals from "./components/PendingPaymentReversals/PendingPaymentReversals.vue";
import ApprovedPaymentReversals from "./components/PendingPaymentReversals/ApprovedPaymentReversals.vue";
import dealer_list from "@/components/DealerManagement/dealer_list.vue";
import dealer_registration from "@/components/DealerManagement/dealer_registration.vue";
import dealer_types from "@/components/DealerManagement/dealer_types.vue";
import discount_management from "@/components/DealerManagement/discount_management.vue";
import Leads_For_Approval from "@/components/LeadsManagement/LeadsForApproval.vue";
import Approved_Leeds from "@/components/LeadsManagement/ApprovedLeeds.vue";
import Create_Area from "@/components/UserManagement/CreateArea.vue";
import view_dealer from "./components/DealerManagement/view_dealer.vue";
import edit_dealer from "./components/DealerManagement/edit_dealer.vue";
import Collection_Bulk_Upload from "./components/COLLECTION_MANAGEMENT/Collection_Bulk_Upload.vue";
import Reject_Payment_Revesals from "./components/PendingPaymentReversals/RejectPaymentRevesals.vue";
import View_Reject_Payment_Revesals from "./components/PendingPaymentReversals/ViewRejectPaymentRevesals.vue";
import Bulk_Upload from "./components/BulkUpload Management/Bulk_Upload.vue";
import RejectedLeads from "./components/LeadsManagement/RejectedLeads.vue";
import CollectionNotify_list from "./components/COLLECTION_MANAGEMENT/CollectionNotify.vue";

const routes = [
    { path: '', name: 'Login', component: Login },
    { path: '/login', name: 'Login', component: Login },
    { path: '/forgot_password', component: ForgotPassword },
    { path: '/add_otp', component: AddOtpComponent },
    { path: '/reset-password', component: ResetPassword },
    {
        path: '', component: App_Bar_and_Navigation_Drawer,
        children: [
            { path: '/dashboard', component: DASHBOARD },
            { path: '/add-products', component: AddProducts },
            { path: '/products-list', component: ProductsList },
            { path: '/products-category', component: addCategory },
            { path: '/category-list', component: CategoryList },
            { path: '/measurement-list', component: MeasurementList },
            { path: '/add-leads', component: AddLeads },
            { path: '/leads-list', component: LeadsList },
            { path: '/user-registration', component: UserRegistration },
            { path: '/users-list', component: UsersList },
            { path: '/create-user-role', component: CreateUserRole },
            { path: '/user-role-list', component: UserRoleList },
            { path: '/sales-management', component: SalesManagement },
            { path: '/total-collections', component: Total_Collections },
            { path: '/total-collections-view/:id', component: Total_Collections_View, name: 'TotalCollectionsView' },
            { path: '/daily-collections', component: Daily_Collections },
            { path: '/daily-collections-view/:id', component: Daily_Collections_View, name: 'DailyCollectionsView' },
            { path: '/overdue-collections', component: Overdue_Collections },
            { path: '/approved-overdues', component: Overdue_Collections_Approved_List },
            { path: '/live-tracking', component: LiveTracking },
            { path: '/overall-tracking-history', component: OverallTrackingHistory },
            { path: '/tracking-history', component: TrackingHistory },
            { path: '/myroute-tracking-history', component: MyrouteTrackingHistary },
            { path: '/create-routes', component: CreateRoutes },
            { path: '/routes-list', component: RoutesList },
            { path: '/organization-management', component: OrganizationManagement },
            { path: '/create-outlet', component: CreateOutlet },
            { path: '/outlet-list', component: OutletList },
            { path: '/all-agents', component: AllAgents },
            { path: '/idling-agents', component: IdlingAgents },
            { path: '/parking-agents', component: ParkingAgents },
            { path: '/user-log', component: UserLog },
            { path: '/OutletType', component: OutletType },
            { path: '/create-organization', component: CreateOrganization },
            { path: '/organization-list', component: OrganizationList },
            { path: '/area-management', component: areaManagement },
            { path: '/daily-pending-inv', component: dailyPending_inv },
            { path: '/dealer-information', component: dealerInformation },
            { path: '/stock-list', component: stockList },
            { path: '/pending-reversals', component: PendingPaymentReversals },
            { path: '/approved-reversals', component: ApprovedPaymentReversals },
            { path: '/dealer-list', component: dealer_list },
            { path: '/dealer-registration', component: dealer_registration },
            { path: '/dealer-types', component: dealer_types },
            { path: '/discount-management', component: discount_management },
            { path: '/Leads-For-Approval', component: Leads_For_Approval },
            { path: '/Approved-Leeds', component: Approved_Leeds },
            { path: '/Create-Area', component: Create_Area },
            { path: '/view-dealer', component: view_dealer },
            { path: '/edit-dealer', component: edit_dealer },
            { path: '/Collection-Bulk-Upload', component: Collection_Bulk_Upload },
            { path: '/Reject-Payment-Revesals', component: Reject_Payment_Revesals },
            { path: '/View-Reject-Payment-Revesals', component: View_Reject_Payment_Revesals },
            { path: '/measurements', component: MeasurementList },
            { path: '/Bulk-Upload', component: Bulk_Upload },
            { path: '/Rejected-Leads', component: RejectedLeads },
            { path: '/CollectionNotify', component: CollectionNotify_list },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');
    const publicRoutes = ['/login', '/forgot_password', '/reset-password', '/add_otp'];
    if (publicRoutes.includes(to.path)) {
        return next();
    }

    if (!token) {
        return next('/login');
    }

    if (token && to.path === '/login') {
        return next('/dashboard');
    }

    if (!canAccessRoute(to.path, 'read')) {
        if (to.path !== '/dashboard' && canAccessRoute('/dashboard', 'read')) {
            return next('/dashboard');
        }

        return next(false);
    }

    next();
});

export default router;